/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react";
import { Link } from "react-router-dom";

function NavBar() {
  useEffect(() => {
    // Get all "navbar-burger" elements
    const navbarBurgers = document.querySelectorAll(".navbar-burger");

    // Add a click event on each of them
    navbarBurgers.forEach((el) => {
      el.addEventListener("click", () => {
        // Get the target from the "data-target" attribute
        const { target } = el.dataset;
        const $target = document.getElementById(target);
        // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
        el.classList.toggle("is-active");
        $target.classList.toggle("is-active");
      });
    });
  }, []);

  return (

    <nav className={window.location.pathname === '/adminlogin' ? "hide" : "navbar"} role="navigation" aria-label="main navigation" style={{ backgroundColor: '#7BC8FF' }}>
      <div className="navbar-brand">
        <div className="navbar-item">
          <b>Mediary</b>
        </div>

        <a role="button" className="navbar-burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
          <span aria-hidden="true" />
          <span aria-hidden="true" />
          <span aria-hidden="true" />
        </a>
      </div>

      <div id="navbarBasicExample" className="navbar-menu">
        <div className="navbar-start">

          <Link to="/" className="navbar-item"> Home </Link>
          {localStorage.getItem("token") && (
            <>
              <Link to="/dashboard" className="navbar-item"> Dashboard </Link>
              <Link to="/channeling" className="navbar-item"> Channeling </Link>
              <Link to="/medicines" className="navbar-item"> Medicines </Link>
              <Link to="/articles" className="navbar-item"> Articles </Link>
            </>
          )}
          {localStorage.getItem("admin-token") && (
            <>
              <Link to="/allusers" className="navbar-item"> All Users </Link>
              <Link to="/articles/all" className="navbar-item"> Articles </Link>
            </>
          )}
        </div>

        <div className="navbar-end">
          {(localStorage.getItem("token") || (localStorage.getItem("admin-token"))) && (
            <div className="navbar-item has-dropdown is-hoverable">
              <a className="navbar-link">
                Menu
              </a>
              <div className="navbar-dropdown">
                {!localStorage.getItem("admin-token") && (
                  <>
                    <Link to="/userprofile" className="navbar-item"> My Account </Link>
                    <hr className="navbar-divider" />
                  </>
                )}

                <a
                  className="navbar-item"
                  onClick={() => {
                    localStorage.clear();
                    window.location.href = "/"; // force refresh to clear react-redux state
                  }}
                >
                  <b> Sign Out </b>
                </a>
              </div>
            </div>
          )}

          {(!localStorage.getItem("token") && (!localStorage.getItem("admin-token"))) && (
            <div className="navbar-item">
              <div className="buttons">
                <Link to="/login"><button className="button is-success">Login</button></Link>
                <Link to="/register"><button className="button is-danger ml-1">Register</button></Link>

              </div>
            </div>
          )}
        </div>
      </div>
    </nav>

  );
}

export default NavBar;
